import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

/**
 * Componente de animación de caja.
 * Muestra una caja animada que "recibe" los productos añadidos.
 */
export default function BoxAnimation({ show }) {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (show) {
            setIsVisible(true);
            const timer = setTimeout(() => {
                setIsVisible(false);
            }, 1500);
            return () => clearTimeout(timer);
        }
    }, [show]);

    return (
        <AnimatePresence>
            {isVisible && (
                <motion.div
                    initial={{ opacity: 0, scale: 0.5, y: -50 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.5, y: -50 }}
                    transition={{ duration: 0.5, type: 'spring', bounce: 0.4 }}
                    className="fixed top-20 right-8 z-50 bg-white rounded-lg shadow-2xl p-6 flex items-center gap-3 border-2 border-primary"
                >
                    <motion.div
                        animate={{
                            rotate: [0, -10, 10, -10, 0],
                            scale: [1, 1.1, 1, 1.1, 1]
                        }}
                        transition={{ duration: 0.6, repeat: 1 }}
                        className="text-5xl"
                    >
                        📦
                    </motion.div>
                    <div>
                        <p className="font-bold text-primary text-lg">¡Agregado!</p>
                        <p className="text-sm text-gray-600">Producto en la caja</p>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
